import { render, staticRenderFns } from "./UpdateInfo.vue?vue&type=template&id=29895ce6&scoped=true&"
import script from "./UpdateInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInfo.vue?vue&type=style&index=0&id=29895ce6&prod&scoped=true&lang=css&"
import style1 from "./UpdateInfo.vue?vue&type=style&index=1&id=29895ce6&prod&lang=scss&scoped=true&"
import style2 from "./UpdateInfo.vue?vue&type=style&index=2&id=29895ce6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29895ce6",
  null
  
)

export default component.exports